import { Progress } from '@/shared/components/ui/progress';
import { OnboardingTask, OnboardingTaskStatus } from '@/types/api/group/onboarding-task';

export function OnboardingProgress({ tasks, title }: { tasks: OnboardingTask[]; title: string }) {
  const completed = tasks.filter((task) => task.status === OnboardingTaskStatus.Completed).length;

  return (
    <div className="space-y-2">
      <div className="flex items-baseline justify-between gap-4">
        <h2 className="text-xl font-bold text-gray-800 dark:text-gray-100">{title}</h2>
        <span className="text-sm text-muted-foreground whitespace-nowrap">
          {completed} av {tasks.length} klart
        </span>
      </div>
      <Progress
        value={tasks.length ? (completed / tasks.length) * 100 : 0}
        className="bg-violet-500/15"
        aria-label="Onboarding-framsteg"
      />
    </div>
  );
}
